import { render, staticRenderFns } from "./DistributorsPage.vue?vue&type=template&id=ca1e1508"
import script from "./DistributorsPage.vue?vue&type=script&lang=js"
export * from "./DistributorsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports